import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ReturnOptionProps } from '../../../../../../types/ProductFactory';
import { hasNumberAfterStreet } from './AddressSearchSelectorV2';

import { Box, Stack } from '@wegroup/design-system';
import AddressSearchInfo from './AddressSearchInfo';
import SearchSelectInputV2, {
  OptionProps,
} from '../../../components/SearchSelectInputV2';
import AddressSearchExtraButton from './AddressSearchExtraButton';

interface Props {
  handleOnCantFind: () => void;
  error?: string;
  onSelected: (arg0: ReturnOptionProps) => void;
  loadOptions: (
    address: string,
    callback: (p: unknown) => void,
  ) => Promise<OptionProps[]> | void;
}

const AddressSearchQuickBE: React.FC<React.PropsWithChildren<Props>> = ({
  error,
  onSelected,
  loadOptions,
  handleOnCantFind,
}) => {
  const { t } = useTranslation();

  const handleLoadOptions: Props['loadOptions'] = (address, cb) => {
    if (!hasNumberAfterStreet(address)) return cb([]);
    loadOptions(address, cb);
  };

  return (
    <>
      <StyledSearchSelectInput
        async
        isClearable
        name="address_search"
        error={error}
        onSelected={onSelected}
        loadOptions={handleLoadOptions}
        placeholder={t(`AdresInput.input.placeholder`)}
        data-test-id="ADVISORY-CONVO_QUESTIONS_ADDRESS-INPUT_SELECT-FIELD"
      />
      <Stack
        mt="6"
        justifyContent="space-between"
        spacing="6"
        direction={{
          base: 'column',
          tablet: 'row',
        }}
      >
        <AddressSearchInfo
          label={t(
            'To find an address, you must provide at least a street and house number',
          )}
        />
        <Box alignSelf="center">
          <AddressSearchExtraButton
            onClick={handleOnCantFind}
            text={t("I can't find my address")}
          />
        </Box>
      </Stack>
    </>
  );
};

const StyledSearchSelectInput = styled(SearchSelectInputV2)`
  min-height: auto;

  label > div {
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export default AddressSearchQuickBE;
